import type { ServiceCategoryRow } from '@/api/booking/getServiceCategoriesQuery/types';
import type { Service } from '@/types/booking';

/**
 * The name of the L1 group a service belongs to: the parent of its L2
 * category, or the category itself when it has no parent.
 */
export function getServiceGroupName(
  service: Service,
  rows: ServiceCategoryRow[],
): string | undefined {
  for (const category of service.categories ?? []) {
    // The service's own category may omit its parent; the category rows say it.
    const parentId =
      category.parentCategoryId ??
      rows.find(({ id }) => id === category.id)?.parentCategoryId;
    if (!parentId) return category.name;
    const parent = rows.find(({ id }) => id === parentId);
    if (parent) return parent.name;
  }
  return undefined;
}
